import React, { Component } from 'react'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import { Col, Row } from 'react-bootstrap'
import moment from 'moment'
import { Heading, ContainerBox } from './AdminStyle';
import { LogeButtonSlim } from '../GeneralStyle'

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { sortDates } from './utils';

@inject('residenceBookingStore', 'userStore', 'adminStore', 'partnersStore')

@observer
class Members extends Component {

  componentWillMount() {
    this.props.adminStore.getUsers()

  }

  onRowClick = row => {
    this.props.history.push(`/internal/admin/members/${row.objectId}`);
  }

  onAddNewUser = () => {
    this.props.history.push(`/internal/admin/members/new`);
  }

  onAddNewCompanyAndMember = () => {
    this.props.history.push(`/internal/admin/onboarding/new`);
  }

  render() {
    const { isAdmin, isLoge } = this.props.userStore;
    const { isUsers, users } = this.props.adminStore;
    // let bookings = []
    // let applicationItems = []
    let userItems = []
    // let partnersItems = []

    if (isUsers) {
      users.map((user, idx) =>
        userItems.push({
          objectId: user.objectId,
          date: moment(user.createdAt).locale("en").format('DD/MM/YYYY'),
          name: user.genderTitle + " " + user.title + " " + user.firstname + " " + user.lastname,
          phone: user.phone,
          company: user.company && user.company.name,
          email: user.username
        })
      )
    }

    const options = {
      onRowClick: this.onRowClick,
      defaultSortName: 'company',
      defaultSortOrder: 'asc'
    };


    if (!isAdmin) {
      //this.props.history.push("/")
    }


    return (
      <div>
      {(isAdmin || isLoge) ?
          <div>

            <Row style={{maxWidth: 1200, margin: "0 auto"}}>
              <Col xs={12} md={12} lg={12} className={'mobile-no-padding'} >
                <ContainerBox>

                  <LogeButtonSlim
                    style={{
                      position: 'relative',
                      display: 'inline-flex',
                      margin: 'auto !important',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: '#FFF',
                      marginRight: "25px",
                      float: "right",
                    }}
                    hoverFontColor={"white"}
                    onClick={this.onAddNewUser}>
                      Mitlgied hinzufügen
                  </LogeButtonSlim>
                  <LogeButtonSlim
                    style={{
                      position: 'relative',
                      display: 'inline-flex',
                      margin: 'auto !important',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: '#FFF',
                      marginRight: "25px",
                      float: "right",
                    }}
                    hoverFontColor={"white"}
                    onClick={this.onAddNewCompanyAndMember}>
                      Mitglied und Firma hinzufügen
                  </LogeButtonSlim>

                  <Heading>MITGLIEDER</Heading>

                  <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 10 }}></div>

                  <div style={{ color: 'black', margin: 15 }} className={'bootstrap-table users'}>
                    {!isUsers
                      ? "Keine Mitglieder"
                      : <BootstrapTable data={userItems} options={ options } borderless={true} hover={true} search pagination bodyStyle={{cursor: "pointer"}} printable>
                        <TableHeaderColumn dataField="objectId" isKey>ID</TableHeaderColumn>
                        <TableHeaderColumn dataField="date" dataSort sortFunc={sortDates}>beigetreten am</TableHeaderColumn>
                        <TableHeaderColumn dataField="name" dataSort>Name</TableHeaderColumn>
                        <TableHeaderColumn dataField="company" dataSort>Firma</TableHeaderColumn>
                        <TableHeaderColumn dataField="phone">Telefonnummer</TableHeaderColumn>
                        <TableHeaderColumn dataField="email">E-Mail</TableHeaderColumn>
                      </BootstrapTable>
                    }
                  </div>
                </ContainerBox>
              </Col>
            </Row>
          </div>
          : ''}
      </div>
    )
  }
}

Members.propTypes = {
  golfCourseStore: MobxPropTypes.observableObject
}

export default Members



// WEBPACK FOOTER //
// /src/components/admin/Members.js